import {Platform, Text} from 'react-native';
import dataConfig from '../../../data/config';

export const CONFIDENTIALITE = (
  <Text>
    Nous traitons vos coordonnées et données commerciales pertinentes
    conformément aux prescriptions légales dans le cadre de la relation
    commerciale existante ou naissante. En saisissant vos données, vous vous
    déclarez disposés à ce que celles- ci soient collectées, traitées ou
    utilisées à des fins légitimes ou aux fins indiquées par vos soins. Notre
    objectif est non seulement de vous proposer une offre en ligne complète et
    instructive mais aussi de préserver vos droits personnels tel définis par
    notre{' '}
    {Platform.OS === 'web' ? (
      <a href={dataConfig.privacyURL}>{'Politique de confidentialités'}</a>
    ) : (
      dataConfig.privacyURL
    )}
  </Text>
);
